import cn from 'classnames'
import qs from 'qs'
import React, { useContext, useEffect, useState } from 'react'
import { Divider, ListItemText, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { buttonSearchCommonStyles } from '../common/styles'
import { get } from '../helpers/Api'
import { setQueryStringWithoutPageReloadPush } from '../helpers/FormatLinks'
import LoadingIndicator from '../loadingindicator'
import { ScrollContext } from '../page/Page'
import DropPreview from './DropPreview'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import DropSearchFilters from './dropsearchfilters/DropSearchFilters'
import DropTopFilters from './droptopfilters/DropTopFilters'
import { useSharedState } from '../waxplorer/Waxplorer'
import FilterListIcon from '@mui/icons-material/FilterList'
import { Button, Modal, ModalContent, useDisclosure } from '@nextui-org/react'

const DropsList = (props) => {
    const { isOpen, onOpen, onOpenChange } = useDisclosure()
    const [open, setIsOpen] = useState(false)
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }
    let values = qs.parse(
        window.location.search.substring(1, window.location.search.length),
    )

    const page = props['page']

    const getValue = (key, def) => {
        if (values[key]) return unescape(values[key])
        return def
    }
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const [offset, setOffset] = useState(getValue('offset', 0))
    const [upcoming, setUpcoming] = useState(getValue('upcoming', false))
    const [pfpsonly, setPfpsonly] = useState(getValue('pfpsonly', false))
    const [highlight, setHighlight] = useState(getValue('highlight', false))
    const [currency, setCurrency] = useState(getValue('currency', 'all'))
    const [orderBy, setOrderBy] = useState(getValue('order_by', 'date_desc'))
    const [market, setMarket] = useState(
        getValue('market', props['market'] ? props['market'] : 'nfthivedrops'),
    )
    const [searchDropId, setSearchDropId] = useState(getValue('drop_id', null))
    const [minPrice, setMinPrice] = useState(getValue('min_price', 0))
    const [maxPrice, setMaxPrice] = useState(getValue('max_price', 0))
    const [searchAuthor, setSearchAuthor] = useState(
        props['collection'] ? props['collection'] : getValue('collection', '*'),
    )
    const authorFilter = !props['collection']

    const [searchVerified, setSearchVerified] = useState(
        getValue(
            'verified',
            searchAuthor && searchAuthor !== '*'
                ? 'all'
                : process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                ? 'all'
                : 'verified',
        ),
    )

    const [drops, setDrops] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [searchCnt, setSearchCnt] = useState(1)
    const [lastSearch, setLastSearch] = useState('')
    const [currencies, setCurrencies] = useState(null)
    const displayCollectionSelector = props['displayCollectionSelector']
    const limit = 12
    const tab = values['tab']

    const showFilters = props['showFilters']

    const parseDrops = (res) => {
        if (offset > 0 && drops) {
            setDrops(drops.concat(res))
        } else {
            setDrops(res)
        }
        setIsLoading(false)
    }

    const parseCurrencies = (res) => {
        setCurrencies(res)
    }

    const getCurrencies = async () => {
        if (process.env.NEXT_PUBLIC_TESTNET === 'TRUE') return
        if (!currencies) {
            get('currencies', 'legacy').then(parseCurrencies)
        }
    }

    const getDrops = async () => {
        get(
            `drops?drop_id=${searchDropId ? searchDropId : ''}&offset=${
                offset ? offset : 0
            }&order_by=${orderBy ? orderBy : ''}&collection=${
                searchAuthor ? searchAuthor : ''
            }&verified=${searchVerified}&min_price=${
                minPrice ? minPrice : ''
            }&max_price=${maxPrice ? maxPrice : ''}&market=${
                market && market !== 'all' ? market : ''
            }&limit=${limit}${highlight ? '&highlight=true' : ''}${
                upcoming ? '&upcoming=true' : ''
            }${pfpsonly ? '&pfpsonly=true' : ''}${
                userName ? '&user=' + userName : ''
            }${currency && currency !== 'all' ? '&currency=' + currency : ''}`,
            'wax-api',
        ).then(parseDrops)
    }

    useEffect(() => {
        setIsLoading(true)
        if (typeof window !== 'undefined') {
            getCurrencies()
            getDrops()
        }
    }, [searchCnt])

    useEffect(() => {
        const asyncFunc = async () => {
            if (offset > 0 && typeof window !== 'undefined') {
                getDrops()
            }
        }
        asyncFunc()
    }, [offset])

    const setOrder = (order) => {
        setVars(
            searchDropId,
            searchAuthor,
            order,
            minPrice,
            maxPrice,
            searchVerified,
            market,
            upcoming,
            pfpsonly,
            currency,
            0,
        )
    }

    const setVars = (
        dropId,
        author,
        order,
        min_price,
        max_price,
        verified,
        market,
        upcoming = false,
        pfpsonly = false,
        currency = 'all',
        offset = 0,
    ) => {
        if (max_price && parseInt(max_price) < parseInt(min_price)) {
            max_price = min_price
        }

        const query = values

        if (dropId) query['drop_id'] = dropId
        else delete query['drop_id']
        if (author && author !== '*') query['collection'] = author
        else delete query['collection']
        if (order && order !== 'date_desc') query['order_by'] = order
        else delete query['order_by']
        if (min_price) query['min_price'] = min_price
        else delete query['min_price']
        if (max_price) query['max_price'] = max_price
        else delete query['max_price']
        if (tab) query['tab'] = tab
        else delete query['tab']
        if (verified !== 'verified') query['verified'] = verified
        else delete query['verified']
        if (market && market !== 'nfthivedrops') query['market'] = market
        else delete query['market']
        if (upcoming) query['upcoming'] = 'true'
        else delete query['upcoming']
        if (pfpsonly) query['pfpsonly'] = 'true'
        else delete query['pfpsonly']
        if (currency && currency !== 'all') query['currency'] = currency
        else delete query['currency']
        if (highlight) query['highlight'] = highlight
        else delete query['highlight']

        setSearchDropId(dropId)
        setSearchAuthor(author)
        setOrderBy(order)
        setMarket(market)
        setMinPrice(min_price)
        setMaxPrice(max_price)
        setUpcoming(upcoming)
        setPfpsonly(pfpsonly)
        setOffset(offset)
        setSearchVerified(verified)
        setCurrency(currency)
        setHighlight(highlight)

        const searchStr = qs.stringify(query)
        setSearchCnt(searchStr !== lastSearch ? searchCnt + 1 : searchCnt)
        setLastSearch(searchStr)

        setQueryStringWithoutPageReloadPush(qs.stringify(query))
    }

    const clearFilters = () => {
        setVars('', '*', 'date_desc', '', '', true, '', upcoming, 'all', 0)
    }

    const { scrollManager, setScrollManager } = useContext(ScrollContext)

    const initScrollManager = async (
        triggered,
        useManager = true,
        scrollUp = false,
    ) => {
        setScrollManager({
            useManager: useManager,
            offset: 0,
            triggered: triggered,
            scrollUp: scrollUp,
        })
    }

    useEffect(() => {
        initScrollManager(false)
    }, [page])

    useEffect(() => {
        initScrollManager(false, !isLoading, false)
    }, [isLoading])

    const loadMore = async () => {
        if (
            !isLoading &&
            drops &&
            drops.length > 0 &&
            drops.length % limit === 0
        ) {
            setIsLoading(true)
            setOffset(offset + limit)
            setVars(
                searchDropId,
                searchAuthor,
                orderBy,
                minPrice,
                maxPrice,
                searchVerified,
                market,
                upcoming,
                pfpsonly,
                currency,
                parseInt(offset) + parseInt(limit),
            )
        }
    }

    useEffect(() => {
        if (scrollManager.triggered) {
            loadMore()
        }
    }, [scrollManager.triggered])

    return (
        <div className={cn('w-full flex flex-col sm:flex-row')}>
            {showFilters && (
                <>
                    <Drawer
                        lockBackgroundScroll={true}
                        open={open}
                        onClose={toggleDrawer}
                        direction="left"
                        className="min-w-[330px] hidden md:block dark:!bg-zinc-900 bg-white p-4 overflow-y-auto"
                    >
                        <div className="flex mb-4 items-center justify-between">
                            <ListItemText>
                                <div className="text-lg dark:text-white text-black font-semibold">
                                    Filters
                                </div>
                            </ListItemText>
                            <Tooltip
                                showArrow={true}
                                key="right"
                                placement="right"
                                content="Close Filters"
                                color="foreground"
                                delay={0}
                                closeDelay={0}
                            >
                                <Button
                                    isIconOnly
                                    aria-label="Like"
                                    onClick={toggleDrawer}
                                    className={cn(
                                        'sm1:w-[36px] sm1:h-[36px] md1:w-[56px] md1:h-[56px] border-2',
                                        buttonSearchCommonStyles,
                                    )}
                                >
                                    <CloseIcon />
                                </Button>
                            </Tooltip>
                        </div>
                        <Divider />
                        <div className="mb-4 " />
                        <DropSearchFilters
                            setVars={setVars}
                            setSearchDropId={setSearchDropId}
                            searchDropId={searchDropId}
                            searchAuthor={searchAuthor}
                            orderBy={orderBy}
                            minPrice={minPrice}
                            maxPrice={maxPrice}
                            searchVerified={searchVerified}
                            market={market}
                            upcoming={upcoming}
                            pfponly={pfpsonly}
                            setMinPrice={setMinPrice}
                            setMaxPrice={setMaxPrice}
                            isLoading={!drops}
                            tab={tab}
                            clearFilters={clearFilters}
                            displayCollectionSelector={
                                displayCollectionSelector
                            }
                            authorFilter={authorFilter}
                            currency={currency}
                            currencies={currencies}
                        />
                    </Drawer>
                    <div className="block md:hidden ">
                        <Modal
                            isOpen={isOpen}
                            placement="bottom-center"
                            onOpenChange={onOpenChange}
                            height="auto"
                            scrollBehavior="inside"
                            classNames={{
                                base: 'max-w-[900px] overflow-y-auto InsideScroll  w-full !mt-24 block md:hidden',
                                body: '  ',
                            }}
                        >
                            <ModalContent>
                                {(onClose) => (
                                    <div className="p-2 ">
                                        <div className="flex items-center justify-between ">
                                            <p className="ml-2 text-lg text-semibold ">
                                                Filters
                                            </p>
                                        </div>
                                        <Divider />
                                        <DropSearchFilters
                                            setVars={setVars}
                                            setSearchDropId={setSearchDropId}
                                            searchDropId={searchDropId}
                                            searchAuthor={searchAuthor}
                                            orderBy={orderBy}
                                            minPrice={minPrice}
                                            maxPrice={maxPrice}
                                            searchVerified={searchVerified}
                                            market={market}
                                            upcoming={upcoming}
                                            pfponly={pfpsonly}
                                            setMinPrice={setMinPrice}
                                            setMaxPrice={setMaxPrice}
                                            isLoading={!drops}
                                            tab={tab}
                                            clearFilters={clearFilters}
                                            displayCollectionSelector={
                                                displayCollectionSelector
                                            }
                                            authorFilter={authorFilter}
                                            currency={currency}
                                            currencies={currencies}
                                        />
                                    </div>
                                )}
                            </ModalContent>
                        </Modal>
                    </div>
                </>
            )}
            <div className={cn('w-full mt-10 sm:mt-8')}>
                <div
                    className={cn(
                        'flex flex-col sm:flex-row justify-center sm:justify-between mb-5',
                    )}
                >
                    <div className="flex items-center justify-between w-full px-4">
                        <div className="">
                            <Button
                                isIconOnly
                                aria-label="Like"
                                onClick={() => setIsOpen(!open)}
                                className={cn(
                                    'w-[64px] md:block hidden h-[58px] mr-2 border-2',
                                    buttonSearchCommonStyles,
                                )}
                            >
                                <FilterListIcon />
                            </Button>
                            <Button
                                isIconOnly
                                aria-label="Like"
                                onPress={onOpen}
                                className={cn(
                                    'w-[64px] block md:hidden h-[64px] mr-2 border-2',
                                    buttonSearchCommonStyles,
                                )}
                            >
                                <FilterListIcon />
                            </Button>
                        </div>
                        <DropTopFilters
                            disabled={isLoading}
                            setOrder={setOrder}
                            orderBy={orderBy}
                            tab={tab}
                        />
                    </div>
                </div>
                <div
                    className={
                        'grid sm:gap-4 gap-2 grid-cols-1 xsse:grid-cols-1 xs1:grid-cols-2 sm1:grid-cols-2 md:grid-cols-2 md1:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 4xl:grid-cols-6 text-center sm:mx-4 mx-2'
                    }
                >
                    {drops &&
                        drops.map((drop, index) => {
                            return (
                                <DropPreview
                                    {...props}
                                    index={index}
                                    drop={drop}
                                />
                            )
                        })}
                </div>
                {isLoading ? <LoadingIndicator /> : ''}
            </div>
        </div>
    )
}

export default DropsList
